import { CountryCode } from 'libphonenumber-js';
import { COUNTRIES, Country } from 'react-easyrocket';

export const getDefaultSelectedCountry = (countryCode: CountryCode): Country | undefined => {
  return COUNTRIES.find((c) => c?.alpha2 === countryCode);
};
